import { gql } from "@apollo/client";

export const CREATE_EXCEPTION = gql`
  mutation CreateException($input: ExceptionMutationInput!) {
    createException(input: $input) {
      exceptionGroup {
        id
        exceptionId
      }
    }
  }
`;
